import React from 'react'
import Helmet from 'react-helmet'

import spinner from '../assets/images/spinner.gif'

const Loading = () => (
  <>
  {/*   <Helmet>
    <title>WFOW - ladet ...</title>
    <meta name="description" content="Loading" />
    </Helmet>  */}

{/*     <div id="loader-wrapper">
        <div id="loader"></div>
    
        <div className="loader-section section-left"></div>
        <div className="loader-section section-right"></div>
    
    </div> */}

    <div className="loader-new">
      <img className="spinner" src={spinner} alt="Loading"/>
    </div>
  </>
  )

export default Loading
